// https://codepen.io/wolthers/pen/LkOLQA
const END = "change";
const START = "ontouchstart" in document ? "touchstart" : "mousedown";
const INPUT = "input";
const MAX_ROTATION = 35;
const SOFTEN_FACTOR = 3;

class RangeInput {
  constructor(el) {
    this.el = el;

    this._handleEnd = this._handleEnd.bind(this);
    this._handleStart = this._handleStart.bind(this);
    this._handleInput = this._handleInput.bind(this);

    //Call the plugin
    $(this.el.querySelector("input[type=range]")).rangeslider({
      polyfill: false, //Never use the native polyfill
      rangeClass: "rangeslider",
      disabledClass: "rangeslider-disabled",
      horizontalClass: "rangeslider-horizontal",
      verticalClass: "rangeslider-vertical",
      fillClass: "rangeslider-fill-lower",
      handleClass: "rangeslider-thumb",
      onInit: function () {
        //No args are passed, so we can't change context of this
        const pluginInstance = this;

        //Move the range-output inside the handle so we can do all the stuff in css
        $(pluginInstance.$element).
        parents(".range").
        find(".range-output").
        appendTo(pluginInstance.$handle);
      }
    });


    this.sliderThumbEl = el.querySelector(".rangeslider-thumb");
    this.outputEl = el.querySelector(".range-output");
    this.inputEl = el.querySelector("input[type=range]");
    this._lastOffsetLeft = 0;
    this._lastTimeStamp = 0;

    this.el.
    querySelector(".rangeslider").
    addEventListener(START, this._handleStart);
  }

  _handleStart(e) {
    this._lastTimeStamp = new Date().getTime();
    this._lastOffsetLeft = this.sliderThumbEl.offsetLeft;

    //Wrap in raf because offsetLeft is updated by the plugin after this fires
    requestAnimationFrame(_ => {
      //Bind through jquery because plugin doesn't fire native event
      $(this.inputEl).on(INPUT, this._handleInput);
      $(this.inputEl).on(END, this._handleEnd);
    });
  }

  _handleEnd(e) {
    //Unbind through jquery because plugin doesn't fire native event
    $(this.inputEl).off(INPUT, this._handleInput);
    $(this.inputEl).off(END, this._handleEnd);

    requestAnimationFrame(
      _ => this.outputEl.style.transform = "rotate(0deg)");

  }

  _handleInput(e) {
    let now = new Date().getTime();
    let timeElapsed = now - this._lastTimeStamp || 1;
    let distance = this.sliderThumbEl.offsetLeft - this._lastOffsetLeft;
    let direction = distance < 0 ? -1 : 1;
    let velocity = Math.abs(distance) / timeElapsed; //pixels / millisecond
    let targetRotation = Math.min(
      Math.abs(distance * velocity) * SOFTEN_FACTOR,
      MAX_ROTATION);


    requestAnimationFrame(
      (_) =>
        this.outputEl.style.transform =
          "rotate(" + targetRotation * -direction + "deg)");


    this._lastTimeStamp = now;
    this._lastOffsetLeft = this.sliderThumbEl.offsetLeft;
  }
};

// Create slider instances.
new RangeInput(document.querySelector(".range-heuwuzzal"));
new RangeInput(document.querySelector(".range-heubinkerl"));
new RangeInput(document.querySelector(".range-streuwuzzal"));

let calcPriceHeuwuzzal = 4;
let countHeuwuzzal = 1;
let calcPriceHeubinkerl = 6;
let countHeubinkerl = 1;
let calcPriceStreuwuzzal = 4;
let countStreuwuzzal = 1;
let calcPriceTotal = 14;

// Format price
function formatPrice(price) {
  return price.toString() + ',-';
}

// Calculate heuwuzzal price.
$('.range-heuwuzzal input').change(function() {
  const priceHeuwuzzal = 4;
  countHeuwuzzal = Math.round(this.value / 1000);
  calcPriceHeuwuzzal = countHeuwuzzal * priceHeuwuzzal;
  let priceElement = document.querySelector('.heuwuzzal .price-value');
  priceElement.innerHTML = formatPrice(calcPriceHeuwuzzal);
  recalculateTotalPrice();
});

// Calculate heubinkerl price.
$('.range-heubinkerl input').change(function() {
  countHeubinkerl = Math.round(this.value / 1000);
  let priceHeubinkerl = 6;
  if (countHeubinkerl >= 10) {
    priceHeubinkerl = 5;
  }
  if (countHeubinkerl >= 30) {
    priceHeubinkerl = 4;
  }
  calcPriceHeubinkerl = countHeubinkerl * priceHeubinkerl;
  let priceElement = document.querySelector('.heubinkerl .price-value');
  priceElement.innerHTML = formatPrice(calcPriceHeubinkerl);
  recalculateTotalPrice();
});

// Calculate streuwuzzal price.
$('.range-streuwuzzal input').change(function() {
  const priceStreuwuzzal = 4;
  countStreuwuzzal = Math.round(this.value / 1000);
  calcPriceStreuwuzzal = countStreuwuzzal * priceStreuwuzzal;
  let priceElement = document.querySelector('.streuwuzzal .price-value');
  priceElement.innerHTML = formatPrice(calcPriceStreuwuzzal);
  recalculateTotalPrice();
});

// Calculate total price.
function recalculateTotalPrice() {
  calcPriceTotal = calcPriceHeuwuzzal + calcPriceHeubinkerl + calcPriceStreuwuzzal;
  let priceElement = document.querySelector('.price-total .price-value');
  priceElement.innerHTML = formatPrice(calcPriceTotal);
}